import { render, staticRenderFns } from "./QuestionPaired.vue?vue&type=template&id=2c16694f&"
import script from "./QuestionPaired.vue?vue&type=script&lang=js&"
export * from "./QuestionPaired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports